import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDelete, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getSummaryReviseRequest = (projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/summary/revise/request`
  return doGet(url)
}

export const updateSummaryReviseRequest = (projectVersionId, optionValue) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/summary/revise/request/${optionValue}`
  return doPut(url, {})
}
